const API_BASE = String(import.meta.env.VITE_BACKEND_URL || (import.meta.env.DEV ? '' : 'https://server.desiredoha.com')).replace(/\/$/, '');

async function parse(response: Response) {
  const payload = await response.json().catch(() => ({}));
  if (!response.ok) throw new Error(payload.message || 'The request could not be completed.');
  return payload.data ?? payload;
}

export async function adminRequest(path: string, options: RequestInit = {}, token = '') {
  const response = await fetch(`${API_BASE}/api/utamu/admin${path}`, {
    ...options,
    headers: {
      Accept: 'application/json',
      ...(options.body ? { 'Content-Type': 'application/json' } : {}),
      ...(token ? { Authorization: `Bearer ${token}` } : {}),
      ...(options.headers || {}),
    },
  });
  return parse(response);
}

export const adminApi = {
  login: (login: string, password: string) => adminRequest('/login', { method: 'POST', body: JSON.stringify({ login, password }) }),
  session: (token: string) => adminRequest('/session', {}, token),
  overview: (token: string) => adminRequest('', {}, token),
  profiles: (token: string, search = '') => adminRequest(`/profiles?search=${encodeURIComponent(search)}`, {}, token),
  profileStatus: (token: string, id: string, status: string, note = '') => adminRequest(`/profiles/${id}/status`, { method: 'PATCH', body: JSON.stringify({ status, note }) }, token),
  users: (token: string, search = '') => adminRequest(`/users?search=${encodeURIComponent(search)}`, {}, token),
  userStatus: (token: string, id: string, status: string, note = '') => adminRequest(`/users/${id}/status`, { method: 'PATCH', body: JSON.stringify({ status, note }) }, token),
  reviews: (token: string) => adminRequest('/reviews', {}, token),
  reviewStatus: (token: string, id: string, status: string) => adminRequest(`/reviews/${id}/status`, { method: 'PATCH', body: JSON.stringify({ status }) }, token),
  verifications: (token: string) => adminRequest('/verifications', {}, token),
  verificationStatus: (token: string, id: string, status: string, note = '') => adminRequest(`/verifications/${id}/status`, { method: 'PATCH', body: JSON.stringify({ status, note }) }, token),
  audit: (token: string) => adminRequest('/audit', {}, token),
};
